import { MENU, MenuItem } from "../constants/menu.constant";
import { showPastEventDetailsMenu } from "./eventEditAccess";

export function isArchivedEvent(status?: string) {
  return status === "archived";
}

/** Active events: standard menu. Archived: + Refunds. Completed/archived: + Event Details. */
export function getMenuForEventStatus(eventStatus?: string): MenuItem[] {
  const archived = isArchivedEvent(eventStatus);
  const pastDetails = showPastEventDetailsMenu(eventStatus);

  return MENU.filter((item) => {
    if (item.archivedOnly) return archived;
    if (item.pastEventOnly) return pastDetails;
    return !item.archivedOnly && !item.pastEventOnly;
  });
}
